// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LayoutDashboard as RawLayoutDashboard } from "lucide-react";
export const LayoutDashboard = /* @__PURE__ */ createIcon(RawLayoutDashboard, "LayoutDashboard", 2);
